import {Component, ViewChild, OnInit} from '@angular/core';
import {SearchService} from "../_core/services/search.service";
import {SearchV2Service} from "../_core/services/search-v2.service";
import {ActionPasser, BahamutHelper, GMList, Grandmaster, Logger, ErrorMessages, Button} from "lo-bahamut";
import {LoadingSpinnerService} from "../_core/services/loading-spinner.service";
import {CURRENT_TENNANT} from "../app.component";
import {CareFindrTenantConfigurationService} from "../_core/apiV2/services/care-findr-tenant-configuration.service";

@Component({
  selector: 'app-nls-landing-page',
  templateUrl: './nls-landing-page.component.html',
  styleUrls: ['./nls-landing-page.component.scss']
})
export class NlsLandingPageComponent implements OnInit{
  private _data: any;
  private templateResponse: any;
  private url: string = "../../assets/nls-landing-page.json";
  public get data(): any { return this._data; }
  @ViewChild('gm') gm: Grandmaster;

  isFilterClicked = true;
  isNLSearchEnabled: boolean | undefined = false;

  constructor(private searchService: SearchService,
              private searchV2Service: SearchV2Service,
              public actionPasser: ActionPasser,
              public gmList: GMList,
              private loadingSpinnerService: LoadingSpinnerService,
              public logger: Logger,
              private lobhelper: BahamutHelper,
              public grandmaster: Grandmaster,
              public errorMessages: ErrorMessages,
              private featureFlagService: CareFindrTenantConfigurationService,) { }

  ngOnInit() {
    // //TODO: To be revised after configuration driven UI is implemented
    // if(CURRENT_TENNANT === 'centerlight' || CURRENT_TENNANT === 'mddoh')
    //   // this.isPlanDropDownEnabled = false;
    //
    // //TODO: To be revised after configuration driven UI is implemented
    // if(CURRENT_TENNANT === 'mddoh')
      // this.isSpecialityHeaderNeedToChange = true;

    // this.getCareFindrJson();
    this.featureFlagService.getTenantFeatureFlags({tenant: CURRENT_TENNANT}).subscribe(response => {
      this.isNLSearchEnabled = response.features?.isNLSearchEnabled;
    })
    this.actionPasser.groupEmitter$.subscribe(async (group: any) => {
      if (group !== undefined && Object.keys(group).length !== 0) {
        this.logger.log(group);
        this.logger.log("groupName Emitted = " + group[0].groupName);
        switch (group[0].groupName) {
          case "showFilter":
            // this.toggleSwitch(group[0].uniqueKey, "cf_nls_button", true);
            this.isFilterClicked = true;
            break;
          case "showNLS":
            // this.toggleSwitch(group[0].uniqueKey, "cf_filter_button", false);
            this.isFilterClicked = false;
            break;
        }
      }
    })
  }

  // go through all components in data and send one by one to the grandmaster
  async addToGrandmaster(viewRef: any, data: any) {
    this.grandmaster.addChildrenToThisView(viewRef, data);
  }

  getCareFindrJson(){
    this.searchService.getCareFindrJson(this.url).subscribe(template => {
      this.templateResponse = template;
      const response = JSON.parse(template);
      this._data = response.componentsConfig;
      this.errorMessages.defaultErrorMessages = response.errorMessages;
      this.loadingSpinnerService.hideLoader();
    })
  }

  // private toggleSwitch(activeKey: string, inactiveChildId: string, isFilterClicked: boolean): void {
  //   const activeButtonRef = this.gmList.gmList[activeKey].reference;
  //   activeButtonRef.classes = "active";
  //
  //   const switchContainerUK = this.gmList.gmList[1].reference.children[0];
  //   if(inactiveChildId == "cf_nls_button"){
  //     const inactiveButtonUK = this.gmList.gmList[switchContainerUK].reference.children[1];
  //     const inactiveButtonRef = this.gmList.gmList[inactiveButtonUK].reference;
  //     inactiveButtonRef.classes = [];
  //   }else{
  //     const inactiveButtonUK = this.gmList.gmList[switchContainerUK].reference.children[0];
  //     const inactiveButtonRef = this.gmList.gmList[inactiveButtonUK].reference;
  //     inactiveButtonRef.classes = [];
  //   }
  //
  //   this.isFilterClicked = isFilterClicked;
  // }

  showFilter(){
    this.isFilterClicked = !this.isFilterClicked;
  }

}
